import React from 'react'
import Layout from '../components/Layouts/Layout'

const Policy = () => {
  return (
    <Layout title={"Policy | Oddyssey"}>
        <h1> Policy page </h1>
    </Layout>
  )
}

export default Policy
